import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { ConcurrenceEnums } from 'src/app/enum/concurrence-enums';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';
import { RentalReportFilterModel } from 'src/app/models/rental/rental-report-filter.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { GroupService } from 'src/app/services/archive/group.service';
import { StoreService } from 'src/app/services/archive/store.service';
import { SubgroupService } from 'src/app/services/archive/subgroup.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { RentalPeriodService } from 'src/app/services/rental/rental-period.service';
import { RentalReportService } from 'src/app/services/rental/rental-report.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { ConcurrenceService } from 'src/app/services/utilities/concurrence.service';
import { CustomValidators } from 'src/app/validators/custom-validators';

@Component({
  selector: 'app-occupancy-percentage',
  templateUrl: './occupancy-percentage.component.html',
  styleUrls: ['./occupancy-percentage.component.scss'],
  standalone: false
})
export class OccupancyPercentageComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('filtersContainer') filtersContainer!: ElementRef;

  branchId: number = 0;
  changeFilters: boolean = false;
  dataReport: CustomTableReport;
  filterObserver?: ResizeObserver;
  filtersHeight: number = 0;
  filteredSubgroups: any[] = [];
  formRentalReportFilter: FormGroup = new FormGroup({});
  isOpened: string | undefined = undefined;
  listArticle: any[] = [];
  listBranch: any[] = [];
  listGroup: any[] = [];
  listReportType: CustomListDropdown[] = [{ label: 'Consolidado', value: 1 }, { label: 'Por Bodega', value: 2 }];
  listStore: any[] = [];
  listSubgroup: any[] = [];
  nameWindow: string = 'Informe de Porcentaje de Ocupación';
  reloadOccupancyPercentage: boolean = true;
  projectName = ProjectName.projectName;
  url: string = "";

  constructor(private articleService: ArticleService,
    private branchService: BranchService,
    private concurrenceService: ConcurrenceService,
    private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private groupService: GroupService,
    private headerService: HeaderService,
    private rentalPeriodService: RentalPeriodService,
    private rentalReportService: RentalReportService,
    private router: Router,
    private storeService: StoreService,
    private subgroupService: SubgroupService,
    private title: Title,
    private toastHandlerService: ToastHandlerService) {
    this.validateForm();
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.getPermission();
    this.getFirstBranchByUserAuthenticatedAsync();
  }

  ngAfterViewInit() {
    this.filterObserver = new ResizeObserver(() => {
      this.filtersHeight = this.filtersContainer?.nativeElement?.offsetHeight || 0;
    });
    this.filterObserver.observe(this.filtersContainer.nativeElement);
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    this.filterObserver?.disconnect();

    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    } else {
      localStorage.clear();
    }

    if (this.branchId != 0) {
      firstValueFrom(this.concurrenceService.closeConcurrence(this.branchId, ConcurrenceEnums.ocupacion));
    }
  }

  changeArticle(articleId: number | null) {
    if (articleId === 0 || articleId === null || articleId === undefined) {
      this.formRentalReportFilter.controls["articleId"].patchValue(0);
    }
    this.changeFilter(false);
  }

  changeBranch(branchId: number) {
    this.branchId = branchId;
    this.changeFilter(true);
  }

  async changeFilter(concurrency: boolean) {
    this.changeFilters = false;
    if (this.dataReport.data && this.dataReport.data.length > 0) {
      this.reloadOccupancyPercentage = concurrency;
    } else {
      this.reloadOccupancyPercentage = true;
    }
  }

  changeGroup(groupId: number | null) {
    this.filterSubgroupByGroupId(groupId);
    if (groupId != 0 && groupId != null) {
      this.formRentalReportFilter.controls["subgroupId"].patchValue(0);
    } else {
      this.formRentalReportFilter.controls["subgroupId"].patchValue(0);
      this.formRentalReportFilter.controls["groupId"].patchValue(0);
    }
    this.changeFilter(false);
  }

  changeReportType(reportType: number) {
    if (reportType === 1) {
      this.formRentalReportFilter.controls["storeId"].patchValue(0);
      setTimeout(() => this.formControlStateService.setControlState(this.formRentalReportFilter, ['storeId'], false));
    } else {
      setTimeout(() => this.formControlStateService.setControlState(this.formRentalReportFilter, ['storeId'], true));
    }
    this.changeFilter(true);
  }

  changeStore(storeId: number | null) {
    if (storeId === 0 || storeId === null || storeId === undefined) {
      this.formRentalReportFilter.controls["storeId"].patchValue(0);
    }
    this.changeFilter(false);
  }

  changeSubgroup(subgroupId: number | null) {
    if (subgroupId != 0 && subgroupId != null) {
      const groupId = this.listSubgroup.find(x => x.value === subgroupId)!.groupId;
      this.formRentalReportFilter.controls["groupId"].patchValue(groupId);
      this.filterSubgroupByGroupId(groupId);
    } else {
      this.formRentalReportFilter.controls["subgroupId"].patchValue(0);
    }
    this.changeFilter(false);
  }

  clear() {
    this.validateForm();
    this.getFirstBranchByUserAuthenticatedAsync();
    this.changeFilter(false);
  }

  async exportExcel() {
    if (this.changeFilters) {
      const dateInitial = this.formRentalReportFilter.get("dateInitial")?.value;
      const initialDate = `${dateInitial.getFullYear()}-${(dateInitial.getMonth() + 1).toString().padStart(2, '0')}`;
      const period = initialDate.slice(5);
      const year = initialDate.slice(0, -3);
      const dateFinal = this.formRentalReportFilter.get("dateFinal")?.value;
      const finalDate = `${dateFinal.getFullYear()}-${(dateFinal.getMonth() + 1).toString().padStart(2, '0')}`;
      const periodFinal = finalDate.slice(5);
      const yearFinal = finalDate.slice(0, -3);

      const modelRentalReportFilter = this.formRentalReportFilter.value as RentalReportFilterModel;
      modelRentalReportFilter.year = parseInt(year);
      modelRentalReportFilter.period = parseInt(period);
      modelRentalReportFilter.yearFinal = parseInt(yearFinal);
      modelRentalReportFilter.periodFinal = parseInt(periodFinal);
      if (this.formRentalReportFilter.get("typeReport")?.value === 2) {
        modelRentalReportFilter.byStores = true;
      }

      try {
        const response = await firstValueFrom(this.rentalReportService.exportRentalReportOccupancyPercentage(modelRentalReportFilter));
        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = modelRentalReportFilter.byStores ? 'Informe de Porcentaje de Ocupación por Bodega.xlsx' : 'Informe de Porcentaje de Ocupación.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al exportar el informe.', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'info',
        'No se encontraron datos para exportar.'
      );
    }
  }

  filterSubgroupByGroupId(groupId: number | null) {
    const rowsFiltered = this.listSubgroup.filter(x => x.groupId === groupId);
    if (groupId != null) {
      this.filteredSubgroups = rowsFiltered;
      const subgroupId = this.formRentalReportFilter.get("subgroupId")?.value;
      const subgroupExists = this.listSubgroup.some(x => x.groupId === groupId && x.value === subgroupId);

      if (subgroupId && !subgroupExists) {
        this.formRentalReportFilter.controls["subgroupId"].patchValue(0);
      }
    } else {
      this.filteredSubgroups = this.listSubgroup;
    }
  }

  async getAllLists() {
    try {
      const [articles, branches, groups, subgroups, stores] = await Promise.all([
        firstValueFrom(this.articleService.getAllArticlesForSelectAsync()),
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.groupService.getAllGroupsForSelectAsync()),
        firstValueFrom(this.subgroupService.getAllSubgroupsForSelectAsync()),
        firstValueFrom(this.storeService.getAllStoresForSelectAsync())
      ]);
      this.listArticle = articles;
      this.listBranch = branches;
      this.listGroup = groups;
      this.listSubgroup = subgroups;
      this.filteredSubgroups = this.listSubgroup;
      this.listStore = stores;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas:', error);
      return false;
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      const branch = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.formRentalReportFilter.controls["branchId"].patchValue(branch.branchId);
      this.branchId = branch.branchId;
      this.getLastRentalPeriod(branch.branchId);
      this.filteredSubgroups = this.listSubgroup;
    } catch (error) {
      console.error("Error al consultar la sucursal:", error);
    }
  }

  async getLastRentalPeriod(branchId: number) {
    try {
      const rentalPeriod = await firstValueFrom(this.rentalPeriodService.getLastRentalPeriod(branchId));
      this.formRentalReportFilter.controls["dateInitial"].patchValue(moment(rentalPeriod.initialDate).startOf('month').toDate());
      this.formRentalReportFilter.controls["dateFinal"].patchValue(moment(rentalPeriod.initialDate).startOf('month').toDate());
    } catch (error) {
      console.error("Error al consultar el periodo de alquiler:", error);
    }
  }

  getPermission() {
    const url = this.router.url as string
    this.url = url.substring(1);
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
        this.router.navigate(['/main']);
      }
    } else {
      localStorage.clear();
    }

    this.getAllLists();
  }

  printReport() {
    if (this.changeFilters) {
      window.print();
    } else {
      this.toastHandlerService.showToast(
        'info',
        'No se encontraron datos para imprimir.'
      );
    }
  }

  async send() {
    Object.keys(this.formRentalReportFilter.controls).forEach(key => {
      const control = this.formRentalReportFilter.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formRentalReportFilter.valid) {
      const dateInitial = this.formRentalReportFilter.get("dateInitial")?.value;
      const initialDate = `${dateInitial.getFullYear()}-${(dateInitial.getMonth() + 1).toString().padStart(2, '0')}`;
      const period = initialDate.slice(5);
      const year = initialDate.slice(0, -3);
      const dateFinal = this.formRentalReportFilter.get("dateFinal")?.value;
      const finalDate = `${dateFinal.getFullYear()}-${(dateFinal.getMonth() + 1).toString().padStart(2, '0')}`;
      const periodFinal = finalDate.slice(5);
      const yearFinal = finalDate.slice(0, -3);

      const modelRentalReportFilter = this.formRentalReportFilter.value as RentalReportFilterModel;
      modelRentalReportFilter.year = parseInt(year);
      modelRentalReportFilter.period = parseInt(period);
      modelRentalReportFilter.yearFinal = parseInt(yearFinal);
      modelRentalReportFilter.periodFinal = parseInt(periodFinal);
      modelRentalReportFilter.reloadOccupancyPercentage = this.reloadOccupancyPercentage;
      if (this.formRentalReportFilter.get("typeReport")?.value === 2) {
        modelRentalReportFilter.byStores = true;
      }

      try {
        this.dataReport = await firstValueFrom(this.rentalReportService.rentalReportOccupancyPercentage(modelRentalReportFilter));
        this.reloadOccupancyPercentage = false;
        if (this.dataReport.data && this.dataReport.data.length != 0 && this.dataReport.data.length != null) {
          this.changeFilters = true;
        } else {
          this.changeFilters = false;
          this.toastHandlerService.showToast('info', 'No se encontraron datos.');
        }
      } catch (error) {
        console.error("Error al consultar el informe:", error);
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      typeReport: {
        required: 'El campo Tipo Informe es obligatorio.',
        min: 'Debe seleccionar un Tipo Informe válido.'
      },
      dateInitial: {
        required: 'El campo Período Inicial es obligatorio.'
      },
      dateFinal: {
        required: 'El campo Período Final es obligatorio.'
      },
      branchId: {
        required: 'El campo Sucursal es obligatorio.',
        min: 'Debe seleccionar una Sucursal válida.'
      },
      groupId: {
        notNumber: 'Debe seleccionar un Grupo válido.'
      },
      subgroupId: {
        notNumber: 'Debe seleccionar un Subgrupo válido.'
      },
      articleId: {
        notNumber: 'Debe seleccionar un Artículo válido.'
      },
      storeId: {
        notNumber: 'Debe seleccionar una Bodega válida.'
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formRentalReportFilter.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  validateForm() {
    this.formRentalReportFilter = this.formBuilder.group({
      typeReport: [1, [Validators.required]],
      dateInitial: ['', [Validators.required]],
      dateFinal: ['', [Validators.required]],
      branchId: [0, [Validators.required, Validators.min(1)]],
      storeId: [0, [CustomValidators.numberOnlyValidator()]],
      articleId: [0, [CustomValidators.numberOnlyValidator()]],
      groupId: [0, [CustomValidators.numberOnlyValidator()]],
      subgroupId: [0, [CustomValidators.numberOnlyValidator()]],
      articleName: [""]
    });
    setTimeout(() => this.formControlStateService.setControlState(this.formRentalReportFilter, ['storeId'], false));
  }

}
